import { render, staticRenderFns } from "./FileMusicIcon.vue?vue&type=template&id=427affa8"
import script from "./FileMusicIcon.vue?vue&type=script&lang=js"
export * from "./FileMusicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports